// extracted by mini-css-extract-plugin
export default {"root":"Todos_root__dKo3J","list":"Todos_list__QAN0o","showMoreBtn":"Todos_showMoreBtn__J40Wm index_btn-icon__n2vie","noTodosInfo":"Todos_noTodosInfo__H+5ML"};